import { useTranslation } from 'react-i18next'

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import RefreshIcon from '@mui/icons-material/Refresh'

import { Room } from '@/core/models/room.model'
import { useIsPds } from '@/hooks/useStaffRole'

import EmergencyPatientSelection from '@/pages/diagnostic/containers/EmergencyPatientSelection'

import { useRefreshEmergencyRoom } from '../model/useRefreshEmergencyRoom'

type EmergencyWaitingViewProps = {
  emergencyRoom: Room
  onSelectPatient: (patientId: string) => void
}

export function EmergencyWaitingView({ emergencyRoom, onSelectPatient }: EmergencyWaitingViewProps) {
  const isPds = useIsPds()
  const { t } = useTranslation()

  const refreshRoom = useRefreshEmergencyRoom(emergencyRoom)

  if (isPds) {
    return <EmergencyPatientSelection onSelect={onSelectPatient} />
  }

  return (
    <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ height: '100%', p: 2 }}>
      <Alert
        severity="info"
        sx={{
          width: '100%',
          maxWidth: 600,
          '& .MuiAlert-message': { width: '100%' },
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography>{t('page.emergency.message.waitingForPatientSelection')}</Typography>
          <Button variant="outlined" color="info" startIcon={<RefreshIcon />} onClick={refreshRoom} sx={{ ml: 2 }}>
            {t('page.emergency.refreshButton.label')}
          </Button>
        </Stack>
      </Alert>
      <Typography variant="body2" color="text.secondary">
        {t('page.emergency.message.refreshInstruction')}
      </Typography>
    </Stack>
  )
}
